import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as object_settings from './courses-data/object_settings.json';
import { AppService } from 'src/app/services/app/app.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CourseService } from 'src/app/services/course/course.service';
@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent {
  Movies = [
    'Blade Runner',
    'Cool Hand Luke',
    'Heat',
    'Juice',
    'The Far Side of the World',
    'Morituri',
    'Napoleon Dynamite',
    'Pulp Fiction'
  ];
  textItem!: string;
  // secondBox!:string;
  @ViewChild('secondBox') secondBox!: ElementRef;
  files: File[] = [];
  outputText!: string;
  public contentDetails: any[] = (object_settings as any).default;
  selectedCourseid: any;
  selectedSectionid: any;
  selectedSubSectionid: any;
  courselist = [
    {
      course_id: "1",
      course_title: "How to use connectteams app",
      sections: [
        {
          title: "Getting Started",
          section_id: "1",
          sub_section: [
            {
              sub_section_id: "ss1",
              sub_s_tit: "How do i download",
              subs_cont: "ThLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"
            },
            {
              sub_section_id: "ss2",
              sub_s_tit: "I didn't Receive",
              subs_cont: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. "
            }
          ]
        },
        {
          title: "App Navigation",
          section_id: "2",
          sub_section: [
            {
              sub_section_id: "ss1",
              sub_s_tit: "How to navigate to connectteam",
              subs_cont: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical "
            },
            {
              sub_section_id: "ss2",
              sub_s_tit: "How to utilize profile tab",
              subs_cont: "All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet."
            }
          ]
        }
      ]
    },
    {
      course_id: "2",
      course_title: "How to use Directory",
      sections: [
        {
          title: "How to use Directory",
          section_id: "1",
          sub_section: [
            {
              sub_section_id: "ss1",
              sub_s_tit: "Intro",
              content_type: "text",
              subs_cont: "Connecteam’s Directory is all about helping you manage all your company work-related contacts!",
              setting: {
                conifirmation_btn: "",
                allow_user_copy_clipboard: "",
                long_text_scroll_to_complete: "",
              }
            },
            {
              sub_section_id: "ss2",
              sub_s_tit: "From the Mobile",
              content_type: "link",
              subs_cont: "https://help.connecteam.com",
              setting: {
                conifirmation_btn: "",
                user_share_link: ""
              }
            }
          ]
        },

      ]
    }
  ]
  public objectType: any = "pdf";

  public  isAdminUser:boolean=false;
  public authToken:any="";
  constructor(private cookieService: CookieService, private http: HttpClient, private appService: AppService,private courseService:CourseService) { }

  ngOnInit(): void {
    let adminUserId = this.cookieService.get('user_id');

  }
  onKeyUp(event: any) {
    this.outputText = this.textItem.replace(/\n/g, '<br>');
  }
  onClick(value: string) {
    this.objectType = value
  }
  onSelect(event: any) {
    if (this.files.length == 0) {
      this.files.push(...event.addedFiles);
    }
    else {
      this.files = [];
      this.files.push(...event.addedFiles);
    }
  }

  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.Movies, event.previousIndex, event.currentIndex);
  }
  onCourseClick(value: string) {
    this.selectedCourseid = value;
    this.selectedSectionid = ''
  }
  onTitleClick(event: Event, section_id: string) {
    event.stopPropagation()
    this.selectedSectionid = section_id;
    this.selectedSubSectionid = ''
  }
  onSubHeaderClick(event: Event, section_id: string) {
    event.stopPropagation()
    this.selectedSubSectionid = section_id;
  }
  onGetToken(){
     if( this.cookieService.get('user_id')){
      this.isAdminUser=true;
      this.authToken=this.cookieService.get('user_id');
      localStorage.setItem('training-portal.authToken',this.authToken);
     }
     else{
      this.authToken=localStorage.getItem('training-portal.authToken');
     }
  }

  onEncryptCall(){
    this.courseService.encrypt().subscribe(data=>{
    })
  }
}
